import { render, staticRenderFns } from "./MsinEditAbout.vue?vue&type=template&id=4989bc41&scoped=true&"
import script from "./MsinEditAbout.vue?vue&type=script&lang=js&"
export * from "./MsinEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989bc41",
  null
  
)

export default component.exports